export function CreditIcon(
  props: React.SVGProps<SVGSVGElement>,
): React.ReactNode {
  return (
    <svg width="1em" height="1em" viewBox="0 0 50 50" fill="none" {...props}>
      <title>Credit</title>
      <path
        d="M25 33.333h2.083c1.39 0 4.167-.833 4.167-4.166 0-3.334-2.778-4.167-4.167-4.167h-4.166c-1.39 0-4.167-.833-4.167-4.167 0-3.333 2.778-4.166 4.167-4.166H25m0 16.666h-6.25m6.25 0V37.5m6.25-20.833H25m0 0V12.5M43.75 25c0 10.355-8.395 18.75-18.75 18.75S6.25 35.355 6.25 25 14.645 6.25 25 6.25 43.75 14.645 43.75 25z"
        stroke="#55BD91"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
